import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: resolve => System.import('../pages/index/index'),
  },
  {
    path: '/index',
    name: 'Index',
    component: resolve => System.import('../pages/index/index'),
  },
  {
    path: '/pl=uplive',
    name: 'Index',
    component: resolve => System.import('../pages/index/index'),
  },
  {
    path: '/record/:betState',
    name: 'Record',
    component: resolve => System.import('../pages/record/record'),
  },
  {
    path: '/record',
    name: 'Record',
    component: resolve => System.import('../pages/record/record'),
  },
  {
    path: '/detail/:detailId',
    name: 'Detail',
    component: resolve => System.import('../pages/detail/detail'),
  },
  {
    path: '/binded',
    name: 'Binded',
    component: resolve => System.import('../pages/binded/binded'),
  },
  {
    path: '/ivtmore',
    name: 'Ivtmore',
    component: resolve => System.import('../pages/invite/rule'),
  },
  {
    path: '/invite/:inviteUid/:ivCode',
    name: 'Invite',
    component: resolve => System.import('../pages/invite/invite'),
  },
  {
    path: '/invite',
    name: 'Invite',
    component: resolve => System.import('../pages/invite/invite'),
  },
  {
    path: '/income/:type',
    name: 'Income',
    component: resolve => System.import('../pages/income/income'),
  },
  {
    path: '/friend',
    name: 'Friend',
    component: resolve => System.import('../pages/friend/friend'),
  },
  {
    path: '/rank',
    name: 'Rank',
    component: resolve => System.import('../pages/rank/rank'),
  },
  {
    path: '/*',
    name: 'Index',
    component: resolve => System.import('../pages/index/index'),
  }
];
// 路由配置
const router = new Router({
  mode:"hash",
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js